// src/components/PrivacyPolicy.tsx
import { Paper, Title, Text, Stack, ScrollArea, Box } from '@mantine/core';

function PrivacyPolicy() {
	return (
		<Box h='calc(100vh - 92px)'>
			<ScrollArea h='100%' type='scroll'>
				<Paper p='md' radius='md' withBorder>
					<Stack gap='md'>
						<Title order={2}>Privacy Policy</Title>
						<Text size='sm'>Last updated: January 21, 2025</Text>

						<Stack gap='xl'>
							<section>
								<Text fw={500} size='lg'>
									1. Introduction
								</Text>
								<Text size='sm'>
									99 Solutions ("we", "our", or "us") is
									committed to protecting your privacy. This
									Privacy Policy explains how we collect, use,
									and safeguard your information when you use
									our Bill Tracker mobile application.
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									2. Information We Collect
								</Text>
								<Text size='sm'>
									We collect information that you provide
									directly to us, including:
								</Text>
								<Text size='sm' component='ul' pl='md' mt='xs'>
									<li>
										Bill information (names, amounts, due
										dates)
									</li>
									<li>User preferences and settings</li>
									<li>Device information and usage data</li>
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									3. How We Use Your Information
								</Text>
								<Text size='sm'>
									We use the collected information to:
								</Text>
								<Text size='sm' component='ul' pl='md' mt='xs'>
									<li>
										Provide and maintain the Bill Tracker
										service
									</li>
									<li>
										Save and track your bills and payments
									</li>
									<li>
										Improve and optimize our application
									</li>
									<li>
										Respond to your requests or questions
									</li>
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									4. Data Storage and Security
								</Text>
								<Text size='sm'>
									Your bill information is stored locally on
									your device. We implement appropriate
									security measures to protect your data, but
									please note that no method of electronic
									storage is 100% secure.
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									5. Your Rights
								</Text>
								<Text size='sm'>You have the right to:</Text>
								<Text size='sm' component='ul' pl='md' mt='xs'>
									<li>Access your personal information</li>
									<li>Correct inaccurate data</li>
									<li>Request deletion of your data</li>
									<li>Export your data</li>
								</Text>
							</section>

							<section>
								<Text fw={500} size='lg'>
									6. Contact Us
								</Text>
								<Text size='sm'>
									If you have any questions about this Privacy
									Policy, please contact us at
									support@99solutions.com
								</Text>
							</section>
						</Stack>
					</Stack>
				</Paper>
			</ScrollArea>
		</Box>
	);
}

export default PrivacyPolicy;
